import { default as audit, auditSlice } from './audit';
export { audit };

import { default as authUser, authUserSlice } from './authUser';
export { authUser };

import { default as company, companySlice } from './company';
export { company };

import { default as credit, creditSlice } from './credit';
export { credit };

import { default as document, documentSlice } from './document';
export { document };

import { default as enquiry, enquirySlice } from './enquiry';
export { enquiry };

import { default as enrolment, enrolmentSlice } from './enrolment';
export { enrolment };

import { default as enterprise, enterpriseSlice } from './enterprise';
export { enterprise };

import { default as event, eventSlice } from './event';
export { event };

import { default as infoAuth, infoAuthSlice } from './infoAuth';
export { infoAuth };

import { default as infoCompany, infoCompanySlice } from './infoCompany';
export { infoCompany };

import { default as infoEnquiry, infoEnquirySlice } from './infoEnquiry';
export { infoEnquiry };

import { default as infoEntity, infoEntitySlice } from './infoEntity';
export { infoEntity };

import { default as infoGhost, infoGhostSlice } from './infoGhost';
export { infoGhost };

import { default as infoIP, infoIPSlice } from './infoIP';
export { infoIP };

import {
  default as infoIntroductionStats,
  infoIntroductionStatsSlice,
} from './infoIntroductionStats';
export { infoIntroductionStats };

import { default as infoLead, infoLeadSlice } from './infoLead';
export { infoLead };

import {
  default as infoOnboarding,
  infoOnboardingSlice,
} from './infoOnboarding';
export { infoOnboarding };

import { default as infoQuery, infoQuerySlice } from './infoQuery';
export { infoQuery };

import { default as infoRelation, infoRelationSlice } from './infoRelation';
export { infoRelation };

import { default as infoSearch, infoSearchSlice } from './infoSearch';
export { infoSearch };

import { default as infoStats, infoStatsSlice } from './infoStats';
export { infoStats };

import { default as infoTag, infoTagSlice } from './infoTag';
export { infoTag };

import { default as infoWorkType, infoWorkTypeSlice } from './infoWorkType';
export { infoWorkType };

import { default as introduction, introductionSlice } from './introduction';
export { introduction };

import { default as job, jobSlice } from './job';
export { job };

import { default as lead, leadSlice } from './lead';
export { lead };

import { default as monitor, monitorSlice } from './monitor';
export { monitor };

import { default as onboarding, onboardingSlice } from './onboarding';
export { onboarding };

import { default as partner, partnerSlice } from './partner';
export { partner };

import { default as payment, paymentSlice } from './payment';
export { payment };

import { default as rate, rateSlice } from './rate';
export { rate };

import { default as subscription, subscriptionSlice } from './subscription';
export { subscription };

import { default as tag, tagSlice } from './tag';
export { tag };

import { default as tradeSummary, tradeSummarySlice } from './tradeSummary';
export { tradeSummary };

import { default as training, trainingSlice } from './training';
export { training };

import { default as transaction, transactionSlice } from './transaction';
export { transaction };

import {
  default as postCompanyBilling,
  postCompanyBillingSlice,
} from './postCompanyBilling';
export { postCompanyBilling };

import {
  default as getCompanyDirectorVerification,
  getCompanyDirectorVerificationSlice,
} from './getCompanyDirectorVerification';
export { getCompanyDirectorVerification };

import {
  default as postCompanyDirectorVerification,
  postCompanyDirectorVerificationSlice,
} from './postCompanyDirectorVerification';
export { postCompanyDirectorVerification };

import {
  default as getCompanyReferrals,
  getCompanyReferralsSlice,
} from './getCompanyReferrals';
export { getCompanyReferrals };

import {
  default as postCompanyReferrals,
  postCompanyReferralsSlice,
} from './postCompanyReferrals';
export { postCompanyReferrals };

import {
  default as exportFcaApproved,
  exportFcaApprovedSlice,
} from './exportFcaApproved';
export { exportFcaApproved };

import {
  default as importFcaApproved,
  importFcaApprovedSlice,
} from './importFcaApproved';
export { importFcaApproved };

import {
  default as exportEnterpriseDailyReport,
  exportEnterpriseDailyReportSlice,
} from './exportEnterpriseDailyReport';
export { exportEnterpriseDailyReport };

import { default as infoSession, infoSessionSlice } from './infoSession';
export { infoSession };

import { default as infoGetCache, infoGetCacheSlice } from './infoGetCache';
export { infoGetCache };

import { default as infoPutCache, infoPutCacheSlice } from './infoPutCache';
export { infoPutCache };

import {
  default as infoDeleteCache,
  infoDeleteCacheSlice,
} from './infoDeleteCache';
export { infoDeleteCache };

import { default as infoCampaign, infoCampaignSlice } from './infoCampaign';
export { infoCampaign };

import { default as infoCustomer, infoCustomerSlice } from './infoCustomer';
export { infoCustomer };

import { default as infoDirector, infoDirectorSlice } from './infoDirector';
export { infoDirector };

import {
  default as infoEnterpriseRole,
  infoEnterpriseRoleSlice,
} from './infoEnterpriseRole';
export { infoEnterpriseRole };

import {
  default as infoEnterprise,
  infoEnterpriseSlice,
} from './infoEnterprise';
export { infoEnterprise };

import { default as infoHealth, infoHealthSlice } from './infoHealth';
export { infoHealth };

import {
  default as infoPartnerBranding,
  infoPartnerBrandingSlice,
} from './infoPartnerBranding';
export { infoPartnerBranding };

import {
  default as infoLegacyRedirect,
  infoLegacyRedirectSlice,
} from './infoLegacyRedirect';
export { infoLegacyRedirect };

import {
  default as infoCheckoutRedirect,
  infoCheckoutRedirectSlice,
} from './infoCheckoutRedirect';
export { infoCheckoutRedirect };

import {
  default as infoValidateEmail,
  infoValidateEmailSlice,
} from './infoValidateEmail';
export { infoValidateEmail };

import { default as checkJob, checkJobSlice } from './checkJob';
export { checkJob };

import { default as payoutsJob, payoutsJobSlice } from './payoutsJob';
export { payoutsJob };

import {
  default as jobCheckoutLink,
  jobCheckoutLinkSlice,
} from './jobCheckoutLink';
export { jobCheckoutLink };

import {
  default as jobCompanyInfo,
  jobCompanyInfoSlice,
} from './jobCompanyInfo';
export { jobCompanyInfo };

import {
  default as exportJobPayouts,
  exportJobPayoutsSlice,
} from './exportJobPayouts';
export { exportJobPayouts };

import {
  default as tradeQuoteApprovalLead,
  tradeQuoteApprovalLeadSlice,
} from './tradeQuoteApprovalLead';
export { tradeQuoteApprovalLead };

import {
  default as matchTradesLead,
  matchTradesLeadSlice,
} from './matchTradesLead';
export { matchTradesLead };

import {
  default as connectTradesLead,
  connectTradesLeadSlice,
} from './connectTradesLead';
export { connectTradesLead };

import {
  default as acceptedJobSummaryLead,
  acceptedJobSummaryLeadSlice,
} from './acceptedJobSummaryLead';
export { acceptedJobSummaryLead };

export const slices = {
  audit: auditSlice,
  authUser: authUserSlice,
  company: companySlice,
  credit: creditSlice,
  document: documentSlice,
  enquiry: enquirySlice,
  enrolment: enrolmentSlice,
  enterprise: enterpriseSlice,
  event: eventSlice,
  infoAuth: infoAuthSlice,
  infoCompany: infoCompanySlice,
  infoEnquiry: infoEnquirySlice,
  infoEntity: infoEntitySlice,
  infoGhost: infoGhostSlice,
  infoIP: infoIPSlice,
  infoIntroductionStats: infoIntroductionStatsSlice,
  infoLead: infoLeadSlice,
  infoOnboarding: infoOnboardingSlice,
  infoQuery: infoQuerySlice,
  infoRelation: infoRelationSlice,
  infoSearch: infoSearchSlice,
  infoStats: infoStatsSlice,
  infoTag: infoTagSlice,
  infoWorkType: infoWorkTypeSlice,
  introduction: introductionSlice,
  job: jobSlice,
  lead: leadSlice,
  monitor: monitorSlice,
  onboarding: onboardingSlice,
  partner: partnerSlice,
  payment: paymentSlice,
  rate: rateSlice,
  subscription: subscriptionSlice,
  tag: tagSlice,
  tradeSummary: tradeSummarySlice,
  training: trainingSlice,
  transaction: transactionSlice,
  postCompanyBilling: postCompanyBillingSlice,
  getCompanyDirectorVerification: getCompanyDirectorVerificationSlice,
  postCompanyDirectorVerification: postCompanyDirectorVerificationSlice,
  getCompanyReferrals: getCompanyReferralsSlice,
  postCompanyReferrals: postCompanyReferralsSlice,
  exportFcaApproved: exportFcaApprovedSlice,
  importFcaApproved: importFcaApprovedSlice,
  exportEnterpriseDailyReport: exportEnterpriseDailyReportSlice,
  infoSession: infoSessionSlice,
  infoGetCache: infoGetCacheSlice,
  infoPutCache: infoPutCacheSlice,
  infoDeleteCache: infoDeleteCacheSlice,
  infoCampaign: infoCampaignSlice,
  infoCustomer: infoCustomerSlice,
  infoDirector: infoDirectorSlice,
  infoEnterpriseRole: infoEnterpriseRoleSlice,
  infoEnterprise: infoEnterpriseSlice,
  infoHealth: infoHealthSlice,
  infoPartnerBranding: infoPartnerBrandingSlice,
  infoLegacyRedirect: infoLegacyRedirectSlice,
  infoCheckoutRedirect: infoCheckoutRedirectSlice,
  infoValidateEmail: infoValidateEmailSlice,
  checkJob: checkJobSlice,
  payoutsJob: payoutsJobSlice,
  jobCheckoutLink: jobCheckoutLinkSlice,
  jobCompanyInfo: jobCompanyInfoSlice,
  exportJobPayouts: exportJobPayoutsSlice,
  tradeQuoteApprovalLead: tradeQuoteApprovalLeadSlice,
  matchTradesLead: matchTradesLeadSlice,
  connectTradesLead: connectTradesLeadSlice,
  acceptedJobSummaryLead: acceptedJobSummaryLeadSlice,
};
